import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  countries: [],
  cities: [],
  citiesByCountry: []
}

const location = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}

export default location
